import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Login/login';
import { css } from '@patternfly/react-styles';
export var LoginMainFooterLinksItem = function LoginMainFooterLinksItem(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$href = _a.href,
      href = _a$href === void 0 ? '' : _a$href,
      _a$target = _a.target,
      target = _a$target === void 0 ? '' : _a$target,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$linkComponent = _a.linkComponent,
      linkComponent = _a$linkComponent === void 0 ? 'a' : _a$linkComponent,
      linkComponentProps = _a.linkComponentProps,
      props = __rest(_a, ["children", "href", "target", "className", "linkComponent", "linkComponentProps"]);

  var LinkComponent = linkComponent;
  return React.createElement("li", Object.assign({
    className: css(styles.loginMainFooterLinksItem, className)
  }, props), React.createElement(LinkComponent, Object.assign({
    className: css(styles.loginMainFooterLinksItemLink),
    href: href,
    target: target
  }, linkComponentProps), children));
};